// src/App.tsx
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from 'sonner'
import { LanguageProvider } from '@/hooks/useLanguage'
import { AuthProvider } from '@/features/auth/AuthProvider'
import { ProtectedRoute } from '@/features/auth/routes/ProtectedRoute'
import { AuthorRoute } from '@/features/auth/routes/AuthorRoute'
import { GuestRoute } from '@/features/auth/routes/GuestRoute'
import { Auth } from '@/features/auth/pages/Auth'
import { AuthCallback } from '@/features/auth/pages/AuthCallback'
import { AccessDenied } from '@/features/auth/pages/AccessDenied'
import { AppLayout } from '@/components/layout/AppLayout'
import { DevPanel } from '@/features/dev/DevPanel'
import { StudioBeta } from '@/features/beta/pages/StudioBeta'
import { RateLimitBanGate } from '@/features/rate-limit/RateLimitBanGate'
import { ConsentReturnGate } from '@/features/mcp/ConsentReturnGate'
import { ProfileLanguageSync } from '@/features/auth/ProfileLanguageSync'
import { JobPoller } from '@/features/ai/JobPoller'
import { CreditsDialogProvider } from '@/features/ai/credits/CreditsDialogContext'
import { TopUpDialog } from '@/features/ai/credits/TopUpDialog'
import { PaymentReturn } from '@/features/ai/credits/PaymentReturn'
import { OAuthConsent } from '@/features/mcp/pages/OAuthConsent'

const App = () => (
  <BrowserRouter>
    <LanguageProvider>
      <AuthProvider>
        <RateLimitBanGate>
          <Toaster
            position="bottom-right"
            richColors
            // Ширина по тексту, прижато к правому краю: без этого короткое
            // «Курс закрыт» стояло в плашке на 356px с пустотой справа. Только с `sm`:
            // на телефоне контейнер sonner шире экрана на свой отступ, и прижатый
            // вправо тост обрезался краем — там он во всю ширину, как задумал sonner.
            // Модальный Radix-диалог ставит на body `pointer-events: none` — без этого кнопка
            // в тосте поверх окна не кликается, а клик уходит «наружу» (скрытые тосты sonner
            // гасит своим, более конкретным правилом).
            style={{ pointerEvents: 'auto' }}
            toastOptions={{ className: 'sm:!w-fit sm:!max-w-[420px] sm:!left-auto sm:!right-0' }}
          />
          <DevPanel />
          <ConsentReturnGate />
          <ProfileLanguageSync />
          <JobPoller />
          <CreditsDialogProvider>
            <TopUpDialog />
            <PaymentReturn />
            <Routes>
              <Route
                path="/auth"
                element={
                  <GuestRoute>
                    <Auth />
                  </GuestRoute>
                }
              />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/access-denied" element={<AccessDenied />} />
              <Route path="/oauth/consent" element={<OAuthConsent />} />
              <Route
                path="/studio-beta"
                element={
                  <ProtectedRoute>
                    <StudioBeta />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <AuthorRoute>
                      <AppLayout />
                    </AuthorRoute>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </CreditsDialogProvider>
        </RateLimitBanGate>
      </AuthProvider>
    </LanguageProvider>
  </BrowserRouter>
)

export default App
